import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import toast from 'react-hot-toast'
import styled, { keyframes } from 'styled-components'
import Cookies from 'js-cookie'
import { BASE_URL } from '../constants'


import { useParams } from 'react-router-dom'
import html2pdf from 'html2pdf.js'
import {
  FaClipboard,
  FaCreditCard,
  FaHashtag,
  FaMapMarkerAlt,
  FaPhone,
  FaRegCalendarAlt,
  FaRulerCombined,
  FaRupeeSign,
  FaSquare,
  FaUserAlt,
} from 'react-icons/fa'

// Get the auth token from cookies
const token = Cookies.get('authToken')

// Create an Axios instance with default headers
const axiosInstance = axios.create({
  baseURL: BASE_URL, // Set your API base URL
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`, // Set the Authorization header for all requests
  },
})
// Define the bounce animation using styled-components
const bounceIn = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
`

const AnimatedCardBody = styled(Card.Body)`
  &.bounce-in {
    animation: ${bounceIn} 0.8s ease forwards;
  }
`

export default function BookingPayment() {
  const { transactionId } = useParams()
  // const { bookingId } = useParams()
  console.log('Tranaction id after render:', transactionId)
  const [booking, setBooking] = useState(null)
  const [customer, setCustomer] = useState(null)
  const [plot, setPlot] = useState(null)
  const [site, setSite] = useState(null)
  const [loading, setLoading] = useState(true)
  const [animate, setAnimate] = useState(false)
  const [transactionDetails, setTransactionDetails] = useState(null)

  // Fetch the transaction details using the transactionId
  useEffect(() => {
    const fetchTransactionDetails = async () => {
      setLoading(true)
      try {
        const transactionResponse = await axiosInstance.get(
          `/get/transaction/details?transaction_id=${transactionId}`,
        )

        const transactionData = transactionResponse.data.data[0]
        if (transactionData) {
          // Extract the bookingId from the transaction details
          const bookingId = transactionData.booking_id
          setTransactionDetails(transactionData)

          // Fetch the booking details using the bookingId
          const bookingResponse = await axiosInstance.get(
            `/get/booking?id=${bookingId}`,
          )
          const bookingData = bookingResponse.data.data[0]
          setBooking(bookingData)

          // Fetch customer details
          const customerResponse = await axiosInstance.get(
            `/customers?id=${bookingData.customer_id}`,
          )
          const customerData = customerResponse.data.data.find(
            (customer) => customer.id === bookingData.customer_id,
          )
          console.log(' customer: ', customerData)
          setCustomer(customerData)

          // Fetch plot details
          const plotResponse = await axiosInstance.get(
            `/plot/search?id=${bookingData.plot_id}`,
          )
          const plotData = plotResponse.data.data.find(
            (plot) => plot.id === bookingData.plot_id,
          )
          setPlot(plotData)

          // Fetch site details
          const siteResponse = await axiosInstance.get(
            `/sites?id=${plotData.site_id}`,
          )

          const siteData = siteResponse.data.data.find(
            (site) => site.id === plotData.site_id,
          )
          setSite(siteData)
        } else {
          toast.error('Transaction not found')
        }
      } catch (error) {
        toast.error('Error fetching data')
        console.error(error)
      } finally {
        setLoading(false)
        setAnimate(true)
      }
    }

    fetchTransactionDetails()
  }, [transactionId])

  const generatePDF = () => {
    const element = document.getElementById('print_page')

    element.classList.add('pdf-style')

    const options = {
      margin: [10, 10, 10, 10],
      filename: `plot-booking-details_${booking.id}_${plot.plot_number}.pdf`,
      image: { type: 'png', quality: 1.0 },
      html2canvas: {
        scale: 2,
        useCORS: true,
      },
      jsPDF: {
        unit: 'pt',
        format: [595.28, 841.89],
        orientation: 'portrait',
      },
    }

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        element.classList.remove('pdf-style')
      })
  }

  if (loading) {
    return <h2>Loading...</h2>
  }

  if (!booking || !customer || !plot || !site) {
    return <h2>Data not available</h2>
  }

  const handlePrint = () => {
    const element = document.getElementById('print_page')

    // Temporarily adjust styles if necessary
    element.classList.add('print-style')

    // Trigger the print dialog
    window.print()

    // Optionally, revert the style back after printing
    element.classList.remove('print-style')
  }
  return (
    <>
      <style>
        {`
        /* Hide print button and other elements when printing */
        @media print {
          .no-print {
            display: none;
          }

            /* Hide the sidebar when printing */
          .position-fixed {
          display: none; /* This hides the SideNavbar */
        }

          /* Ensure content takes up the full page */
          body, html {
            height: 100%;
            width: 100%;
            margin: 0;
            padding: 0;
            font-size: 11px;
          }

          #print_page {
            height: 100%;
            width: 150%;
            margin-top: 5rem;
            padding: 20px; /* Adjust padding */
            overflow: hidden; /* Prevent scrolling */
            transform: translateX(-50%); /* Center horizontally */
            position: relative; /* Position relative to allow translation */
            left: 50%; /* Move from the left */
            box-shadow: none !important;
            border: none !important;
            
    
          }
            
        }
        `}
      </style>
      <AnimatedCardBody className={animate ? 'bounce-in' : ''}>
        <Container className="mt-2">
          <Row className="justify-content-end">
            <Col xs={12} md={10} lg={10}>
              <Card className="shadow-lg p-5" id="print_page">
                <Card.Body className={animate ? 'bounce-in' : ''}>
                  <div>
                    <h2 className="text-center fw-bold text-success">
                      Transaction Receipt
                    </h2>
                    <p className="text-muted text-center">
                      Your payment has been successfully received
                    </p>
                  </div>
                  <h5
                    className="text-primary text-center fw-bold mb-4 text-primary"
                    style={{ marginBottom: '4rem', marginTop: '3rem' }}
                  >
                    {site.name ? site.name.toUpperCase() : 'N/A'}
                  </h5>
                  {/* Booking Details Section */}
                  <div
                    className="fluid mt-5 mx-auto"
                    style={{ fontSize: '14px' }}
                  >
                    <Container className="mx-auto">
                      <Row className="mx-auto">
                        <Col xs={12} sm={6} className="text-start">
                          <p>
                            <FaClipboard /> <strong>Booking ID : </strong>
                            {booking.id}
                          </p>
                          <p>
                            <FaUserAlt /> <strong>Booked by : </strong>
                            {customer.title}
                            {'.'} {customer.name || 'N/A'}
                          </p>
                          <p>
                            <FaUserAlt /> <strong>Guardian Name : </strong>
                            {customer.guardian_title}
                            {'.'} {customer.guardian_name || 'N/A'}
                          </p>
                          <p>
                            <FaRegCalendarAlt />{' '}
                            <strong>Transaction Date: </strong>
                            {new Date(
                              transactionDetails.transaction_date,
                            ).toLocaleDateString('en-GB', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            })}
                          </p>
                        </Col>
                        <Col xs={12} sm={4} className="text-start  mx-auto">
                          <p>
                            <FaCreditCard /> <strong>Payment mode : </strong>
                            {transactionDetails.payment_method || 'N/A'}
                          </p>
                          <p>
                            <FaSquare /> <strong>Block : </strong>
                            {plot.block || 'N/A'}
                          </p>
                          <p>
                            <FaRulerCombined /> <strong>Plot Area : </strong>
                            {plot.plot_size || 'N/A'}
                          </p>
                          <p>
                            <FaHashtag /> <strong>Plot Number : </strong>
                            {plot.plot_number || 'N/A'}
                          </p>
                          <p className="text-danger">
                            <FaRupeeSign />{' '}
                            <strong>Transaction Amount : </strong>₹{' '}
                            {transactionDetails.transaction_amount}
                          </p>
                        </Col>
                      </Row>
                      <Row className="text-start mx-0">
                        <p>
                          <FaMapMarkerAlt /> <strong>Address : </strong>
                          {customer.address}
                        </p>
                      </Row>
                    </Container>
                  </div>
                  {/* Footer Section */}
                  <div className="text-start" style={{ marginTop: '50px' }}>
                    <Container>
                      <Row>
                        <Col>
                          <p className="fw-bold">
                            <i>
                              Thank you! The payment have been captured with us.
                              Please Refer to above booking and transaction
                              details.
                            </i>
                          </p>
                          <br />
                          <h5 className="fw-bold" style={{ marginTop: '45px' }}>
                            Ishan City Builders Private Limited
                          </h5>
                          <p className="mt-1">[ Authorized Signatory]</p>
                          <h6 className="mt-5">
                            Terms:
                            <ol>
                              <li>
                                This receipt is subjected to realization of
                                cheque/draft
                              </li>
                              <li>
                                Allotted plot will be cancelled/shifted if the
                                committed is not done with in given time.
                              </li>
                              <li>
                                In case of refund, 30% will be deducted and rest
                                will be send in next 90 days.
                              </li>
                              <li>Booking amount is non-refundable.</li>
                              <li>
                                This Receipt only for Record purpose, it is not
                                claimable in any legal process.
                              </li>
                              <li>This receipt not valid unless signed.</li>
                            </ol>
                          </h6>
                        </Col>
                      </Row>
                    </Container>
                    <hr style={{ marginTop: '-2px' }} />
                    <Row>
                      <div
                        style={{
                          // padding: '1rem', // Adds spacing around the text
                          marginTop: '-2px', // Adds space above the div
                          textAlign: 'center', // Centers the text
                          fontSize: '14px', // Slightly larger font
                          color: '#333', // Neutral text color
                        }}
                      >
                        For more details, please mail us at{' '}
                        <a
                          href="mailto: ishanbuilderspvtltd@gmail.com"
                          style={{
                            textDecoration: 'none',
                            color: 'sky',
                          }}
                        >
                          ishanbuilderspvtltd@gmail.com
                        </a>{' '}
                        or visit our website{' '}
                        <a
                          href="https://ishanbuilders.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: 'none',
                            color: 'sky',
                          }}
                        >
                          www.ishanbuilders.com
                        </a>
                      </div>
                    </Row>
                  </div>
                </Card.Body>
              </Card>

              <Row className="mt-4 justify-content-end">
                <Col xs="auto" className="d-flex gap-1">
                  <Button
                    variant="outline-secondary"
                    className="mb-2 no-print"
                    onClick={handlePrint}
                  >
                    <i className="bi bi-file-earmark-pdf"></i> Print
                  </Button>
                  <Button
                    variant="outline-primary"
                    className="fw-bold mb-2 no-print"
                    onClick={generatePDF}
                  >
                    <i className="bi bi-file-earmark-pdf"></i> Download PDF
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </AnimatedCardBody>
    </>
  )
}
